import { render, staticRenderFns } from "./MassAssignment.vue?vue&type=template&id=010cb3e4"
import script from "./MassAssignment.vue?vue&type=script&lang=js"
export * from "./MassAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports